// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Webinars24FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Webinars24Filled: FC<Webinars24FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="24"
        >
            <path d="M21 21V5H3v8H1V5c0-.55.196-1.02.587-1.413A1.926 1.926 0 0 1 3 3h18c.55 0 1.02.196 1.413.587C22.803 3.98 23 4.45 23 5v14c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0 1 21 21ZM9 14c-1.1 0-2.042-.392-2.825-1.175C5.392 12.042 5 11.1 5 10s.392-2.042 1.175-2.825C6.958 6.392 7.9 6 9 6s2.042.392 2.825 1.175C12.608 7.958 13 8.9 13 10s-.392 2.042-1.175 2.825C11.042 13.608 10.1 14 9 14Zm-8 8v-2.8c0-.567.146-1.087.438-1.563.291-.474.679-.837 1.162-1.087a14.843 14.843 0 0 1 3.15-1.163A13.76 13.76 0 0 1 9 15c1.1 0 2.183.13 3.25.387 1.067.259 2.117.646 3.15 1.163.483.25.87.613 1.162 1.087.292.476.438.996.438 1.563V22H1Z" />
        </svg>
    );
};

export default Webinars24Filled;
